export const FilterType = Object.freeze({ genre: 'genre', market: 'market' })

export const RELATIONSHIP_TYPES = {
  INDUSTRY_CONTACT: 'industry-contact',
  COWORKER: 'coworker'
}

export const INDUSTRY_OPTIONS = {
  RADIO: 'radio',
  PRESS_PUBLICITY_MEDIA: 'press-publicity-media',
  OTHER: 'other'
}

export const AUTH_ERRORS = {
  NONE: 'NONE',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
  EMAIL_TAKEN: 'EMAIL_TAKEN',
  CHECK_EMAIL_FAILED: 'CHECK_EMAIL_FAILED',
  INVALID_TOKEN: 'INVALID_TOKEN',
  TERMS_NOT_ACCEPTED: 'TERMS_NOT_ACCEPTED',
  VERIFICATION_PENDING: 'VERIFICATION_PENDING',
  INVALID_EMAIL_TOKEN: 'INVALID_EMAIL_TOKEN',
  SIGNUP_FAILED: 'SIGNUP_FAILED'
}

export const CONNECTIONS_ERRORS = {
  INVITATION_ALREADY_ACCEPTED: 'INVITATION_ALREADY_ACCEPTED',
  INVITATION_NOT_FOR_USER: 'INVITATION_NOT_FOR_YOU'
}



export const RELEASE_SORT_OPTIONS = [
  {
    key: '-date',
    analyticsLabel: 'All time',
    translationKey: 'home.sort-all-time'
  },
  {
    key: '-7days',
    analyticsLabel: 'Last 7 days',
    translationKey: 'home.sort-last-7-days'
  },
  {
    key: '-30days',
    analyticsLabel: 'Last 30 days',
    translationKey: 'home.sort-last-30-days'
  },
  {
    key: 'trending',
    analyticsLabel: 'Trending songs',
    info: true,
    translationKey: 'home.sort-trending-songs'
  }
]

export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  CANCELED: 'canceled',
  RETRYING: 'retrying',
  PAUSED: 'paused'
}

export const SearchCategory = Object.freeze({
  top: 'top',
  tracks: 'tracks',
  artists: 'artists',
  labels: 'labels',
  releases: 'releases'
})

export const ReleaseFrequency = Object.freeze({
  none: {
    value: 'none',
    display: 'enum.ReleaseFrequency.none'
  },
  daily: {
    value: 'daily',
    display: 'enum.ReleaseFrequency.daily'
  },
  weekly: {
    value: 'weekly',
    display: 'enum.ReleaseFrequency.weekly'
  },
  track: {
    value: 'track',
    display: 'enum.ReleaseFrequency.per-release'
  }
})

export const AnchorPositions = Object.freeze({
  topLeft: 'topLeft',
  topRight: 'topRight',
  topCenter: 'topCenter',
  leftCenter: 'leftCenter',
  rightCenter: 'rightCenter',
  bottomLeft: 'bottomLeft',
  bottomCenter: 'bottomCenter',
  bottomRight: 'bottomRight'
})

export const PopupDirections = Object.freeze({
  up: 'up',
  down: 'down',
  left: 'left',
  right: 'right',
  upLeft: 'upLeft',
  upRight: 'upRight',
  downLeft: 'downLeft',
  downRight: 'downRight',
  downCenter: 'downCenter'
})

export const ModalTypes = Object.freeze({
  fixed: 'fixed',
  absolute: 'absolute'
})

export const AudioFormat = Object.freeze({
  wav: {
    value: 'wav',
    display: 'enum.AudioFormat.wav'
  },
  mp3: {
    value: 'mp3',
    display: 'enum.AudioFormat.mp3'
  }
})

export const MetaFormat = Object.freeze({
  pdf: {
    value: 'pdf',
    display: 'enum.MetaFormat.pdf'
  },
  csv: {
    value: 'csv',
    display: 'enum.MetaFormat.csv'
  }
})

export const ReportSource = Object.freeze({
  none: {
    value: 'None',
    display: 'enum.ReportSource.none'
  },
  bds: {
    value: 'BDS',
    display: 'enum.ReportSource.bds'
  },
  cmj: {
    value: 'CMJ',
    display: 'enum.ReportSource.cmj'
  },
  fmqb: {
    value: 'FMQB',
    display: 'enum.ReportSource.fmqb'
  },
  hits: {
    value: 'HITS',
    display: 'enum.ReportSource.hits'
  },
  musicrow: {
    value: 'Music Row',
    display: 'enum.ReportSource.musicrow'
  },
  mediabase: {
    value: 'Mediabase',
    display: 'enum.ReportSource.mediabase'
  },
  texasmusicchart: {
    value: 'Texas Music Chart',
    display: 'enum.ReportSource.texasmusicchart'
  },
  other: {
    value: 'Other',
    display: 'enum.ReportSource.other'
  }
})

export const ReportFormat = Object.freeze({
  activerock: {
    value: 'Active Rock',
    display: 'enum.ReportFormatOptions.activerock'
  },
  adult: {
    value: 'Adult Contemporary',
    display: 'enum.ReportFormatOptions.adult'
  },
  adulthit: {
    value: 'Adult Hits',
    display: 'enum.ReportFormatOptions.adulthit'
  },
  alternative: {
    value: 'Alternative',
    display: 'enum.ReportFormatOptions.alternative'
  },
  americana: {
    value: 'Americana',
    display: 'enum.ReportFormatOptions.americana'
  },
  christianac: {
    value: 'Christian-AC',
    display: 'enum.ReportFormatOptions.christianac'
  },
  christianchr: {
    value: 'Christian-CHR',
    display: 'enum.ReportFormatOptions.christianchr'
  },
  christiancountry: {
    value: 'Christian-Country',
    display: 'enum.ReportFormatOptions.christiancountry'
  },
  christianinspo: {
    value: 'Christian-Inspo',
    display: 'enum.ReportFormatOptions.christianinspo'
  },
  christianpraise: {
    value: 'Christian-Praise & Worship',
    display: 'enum.ReportFormatOptions.christianpraise'
  },
  christianrhythmic: {
    value: 'Christian-Rhythmic',
    display: 'enum.ReportFormatOptions.christianrhythmic'
  },
  christianrock: {
    value: 'Christian-Rock',
    display: 'enum.ReportFormatOptions.christianrock'
  },
  christiangospel: {
    value: 'Christian-Southern Gospel',
    display: 'enum.ReportFormatOptions.christiangospel'
  },
  classichits: {
    value: 'Classic Hits',
    display: 'enum.ReportFormatOptions.classichits'
  },
  classicrock: {
    value: 'Classic Rock',
    display: 'enum.ReportFormatOptions.classicrock'
  },
  classical: {
    value: 'Classical',
    display: 'enum.ReportFormatOptions.classical'
  },
  country: {
    value: 'Country',
    display: 'enum.ReportFormatOptions.country'
  },
  dance: {
    value: 'Dance',
    display: 'enum.ReportFormatOptions.dance'
  },
  gospel: {
    value: 'Gospel',
    display: 'enum.ReportFormatOptions.gospel'
  },
  hotac: {
    value: 'Hot AC',
    display: 'enum.ReportFormatOptions.hotac'
  },
  jazz: {
    value: 'Jazz',
    display: 'enum.ReportFormatOptions.jazz'
  },
  latin: {
    value: 'Latin',
    display: 'enum.ReportFormatOptions.latin'
  },
  latinregional: {
    value: 'Latin-Regional Mexican',
    display: 'enum.ReportFormatOptions.latinregional'
  },
  latinregionalcont: {
    value: 'Latin-Regional Cont.',
    display: 'enum.ReportFormatOptions.latinregionalcont'
  },
  latintropical: {
    value: 'Latin-Tropical',
    display: 'enum.ReportFormatOptions.latintropical'
  },
  latinurban: {
    value: 'Latin-Urban',
    display: 'enum.ReportFormatOptions.latinurban'
  },
  mainstreamac: {
    value: 'Mainstream AC',
    display: 'enum.ReportFormatOptions.mainstreamac'
  },
  mainstreamrock: {
    value: 'Mainstream Rock',
    display: 'enum.ReportFormatOptions.mainstreamrock'
  },
  metal: {
    value: 'Metal',
    display: 'enum.ReportFormatOptions.metal'
  },
  newstalk: {
    value: 'News/Talk',
    display: 'enum.ReportFormatOptions.newstalk'
  },
  npr: {
    value: 'Non-commercial/NPR',
    display: 'enum.ReportFormatOptions.npr'
  },
  rhythmic: {
    value: 'Rhythmic',
    display: 'enum.ReportFormatOptions.rhythmic'
  },
  rhythmicac: {
    value: 'Rhythmic AC',
    display: 'enum.ReportFormatOptions.rhythmicac'
  },
  smoothjazz: {
    value: 'Smooth Jazz/AC',
    display: 'enum.ReportFormatOptions.smoothjazz'
  },
  top40: {
    value: 'Top 40/CHR',
    display: 'enum.ReportFormatOptions.top40'
  },
  triplea: {
    value: 'Triple A',
    display: 'enum.ReportFormatOptions.triplea'
  },
  urban: {
    value: 'Urban',
    display: 'enum.ReportFormatOptions.urban'
  },
  urbanac: {
    value: 'Urban AC',
    display: 'enum.ReportFormatOptions.urbanac'
  },
  other: {
    value: 'Other',
    display: 'enum.ReportFormatOptions.other'
  }
})

export const BooleanOptions = Object.freeze({
  yes: {
    value: 'Yes',
    display: 'enum.BooleanOptions.yes'
  },
  no: {
    value: 'No',
    display: 'enum.BooleanOptions.no'
  }
})

export const RoleOptions = Object.freeze({
  radio: {
    value: 'Radio',
    display: 'enum.RoleOptions.radio'
  },
  press: {
    value: 'Press',
    display: 'enum.RoleOptions.press'
  },
  other: {
    value: 'Other',
    display: 'enum.RoleOptions.other'
  }
})

export const OccupationOptions = Object.freeze({
  newspaper: {
    value: 'Newspaper',
    display: 'enum.OccupationOptions.newspaper'
  },
  magazine: {
    value: 'Magazine',
    display: 'enum.OccupationOptions.magazine'
  },
  onlineBlogger: {
    value: 'Online/Blogger',
    display: 'enum.OccupationOptions.onlineBlogger'
  },
  streetPress: {
    value: 'Street Press',
    display: 'enum.OccupationOptions.streetPress'
  },
  freelance: {
    value: 'Freelance',
    display: 'enum.OccupationOptions.freelance'
  },
  other: {
    value: 'Other',
    display: 'enum.OccupationOptions.other'
  }
})

export const NotificationType = Object.freeze({
  addDownloadQueue: 'addDownloadQueue',
  downloadFinished: 'downloadFinished',
  flag: 'flag',
  unFlag: 'unFlag',
  archive: 'archive',
  unArchive: 'unArchive',
  settingSaved: 'settingSaved',
  profileUpdated: 'profileUpdated',
  playlistCreated: 'playlistCreated',
  playlistUpdated: 'playlistUpdated',
  addedToPlaylist: 'addedToPlaylist',
  hasError: 'hasError',
  contactRequestSent: 'contactRequestSent',
  connectionAccepted: 'connectionAccepted',
  invitationAlreadyAccepted: 'invitationAlreadyAccepted',
  invitationNotForUser: 'invitationNotForUser',
  emailSuccessfullyLinked: 'emailSuccessfullyLinked',
  emailSuccessfullyUnlinked: 'emailSuccessfullyUnlinked',
  emailLinkingFailed: 'emailLinkingFailed',
  emailUnlinkingFailed: 'emailUnlinkingFailed'
})

export const optionsOfEnum = (EnumType) => {
  return Object.keys(EnumType).map((key) => EnumType[key])
}

export const DownloadTaskType = Object.freeze({
  release: 'release',
  song: 'song',
  video: 'video',
  playlist: 'playlist'
})

export const DownloadTaskStatus = Object.freeze({
  waiting: 'waiting',
  loading: 'loading',
  finished: 'finished',
  failed: 'failed'
})

export const marketOptions = Object.freeze({
  white: 'white',
  darkBlue: 'dark-blue',
  two: '2x',
  three: '3x'
})


export const PlaylistSort = Object.freeze({
  newest: {
    value: '-date',
    display: 'enum.PlaylistSort.newest'
  },
  atoz: {
    value: 'name',
    display: 'enum.PlaylistSort.atoz'
  },
  starred: {
    value: '-pinned',
    display: 'enum.PlaylistSort.starred'
  },
  none: {
    value: '',
    display: '  '
  }
})

export const SongTableColumns = Object.freeze({
  index: 'index',
  coverart: 'coverart',
  artist: 'artist',
  title: 'title',
  duration: 'duration',
  available: 'available',
  labels: 'labels',
  genres: 'genres',
  markets: 'markets',
  availableDate: 'available',
  impactDate: 'impactdate'
})

export const getOptionDisplays = (EnumType) => {
  return Object.keys(EnumType).map((key) => EnumType[key].display)
}

export const getValueFromDisplay = (EnumType, display) => {
  const optionKey = Object.keys(EnumType).filter(
    (key) => EnumType[key].display === display
  )
  if (optionKey !== undefined && optionKey !== null) {
    return EnumType[optionKey].value
  } else {
    return null
  }
}

export const getDisplayFromValue = (EnumType, value) => {
  const optionKey = Object.keys(EnumType).filter(
    (key) => EnumType[key].value === value
  )
  if (optionKey !== undefined && optionKey !== null && optionKey.length !== 0) {
    return EnumType[optionKey].display
  } else {
    return null
  }
}

export default {
  FilterType,
  SearchCategory,
  DownloadTaskType,
  marketOptions,
  RoleOptions,
  BooleanOptions,
  ReportSource,
  ReportFormat
}
